import axios from "axios";

function ErrorAdd(errorJson, url) {
    axios.post('/api_main/other/errorJsAdd', { ID_Service: process.env.REACT_APP_ID_SERVICE, Error_Json: JSON.stringify(errorJson), Url: url })
        .then((res) => {

        })
        .catch((err) => {

        });
}

export default ErrorAdd;